import { FormController } from '../../controllers/form-controller.class'

class TechnicalControlFormController extends FormController {
  /** @ngInject */
  constructor($scope, $injector, putlistServiceApiV2) {
    super($scope, $injector)
    this.putlistServiceApiV2 = putlistServiceApiV2
  }

  /** Инициализация компонента. */
  $onInit() {}

  /** Сформировать отчет. */
  print() {
    const params = {}
    if (this.dateFrom) {
      params.date_from = $.fn.dateutils.date2sql(this.dateFrom)
    }
    if (this.dateTo) {
      params.date_to = $.fn.dateutils.date2sql(this.dateTo)
    }
    if (this.firm) {
      params.firm = this.firm
    }
    this.putlistServiceApiV2.getTechnicalControlJournal(params)
  }

  close() {
    window.close()
  }
}

export const TechnicalControlFormComponent = {
  template: require('./technical-control-form.component.html'),
  styles: [require('./technical-control-form.component.scss')],
  bindings: {
    onSave: '&',
    onClose: '&',
    ourFirms: '<',
  },
  controller: TechnicalControlFormController,
}
